import type { TODO } from '../util/types';
// import ContactData from './ContactData'
import type { NuxtApp } from 'nuxt/app';
import type { apiNuxt } from '../api/apiNuxt';

type ExtendedApi = ReturnType<typeof apiNuxt>['API'] & {
  baseUrl: string;
  version: string;
};

interface ContactData {
  [key: string]: TODO;
}

class TeamCompliance {
  completedActionsCount: number;
  completedItemsCount: number;
  completedPercentage: number;
  requiredActionsCount: number;
  totalItemsCount: number;
  complianceTrackingEnabled: boolean;

  constructor(data: TeamCompliance) {
    this.completedActionsCount = data.completedActionsCount;
    this.completedItemsCount = data.completedItemsCount;
    this.completedPercentage = data.completedPercentage;
    this.requiredActionsCount = data.requiredActionsCount;
    this.totalItemsCount = data.totalItemsCount;
    this.complianceTrackingEnabled = data.complianceTrackingEnabled;
  }
}

interface StudyTeamConstructorArgs {
  app: NuxtApp['vueApp'] & {
    $nuxt: NuxtApp & {
      $API: ExtendedApi;
    };
  };
  activeMemberCount: number;
  channelId: number;
  contactData: ContactData;
  createDateTimeMillis: number;
  createdByUserId: number;
  displayName: string;
  id: number;
  isActive: boolean;
  isInvestigatorSite: boolean;
  name: string;
  participantType: string;
  statusId: number;
  statusName: string;
  studyTeamCompliance: TeamCompliance;
  studyTeamDetailUrl: string;
  teamType: string;
}

class StudyTeam {
  app: NuxtApp['vueApp'] & {
    $nuxt: NuxtApp & {
      $API: ExtendedApi;
    };
  };
  activeMemberCount: number;
  channelId: number;
  contactData: ContactData;
  createDateTimeMillis: number;
  createdByUserId: number;
  displayName: string;
  id: number;
  isActive: boolean;
  isInvestigatorSite: boolean;
  name: string;
  participantType: string;
  statusId: number;
  statusName: string;
  studyTeamCompliance: TeamCompliance;
  studyTeamDetailUrl: string;
  teamType: string;

  constructor({ app, ...studyTeam }: StudyTeamConstructorArgs) {
    this.app = app;
    this.activeMemberCount = studyTeam.activeMemberCount;
    this.channelId = studyTeam.channelId;
    this.contactData = studyTeam.contactData;
    this.createDateTimeMillis = studyTeam.createDateTimeMillis;
    this.createdByUserId = studyTeam.createdByUserId;
    this.displayName = studyTeam.displayName;
    this.id = studyTeam.id;
    this.isActive = studyTeam.isActive;
    this.isInvestigatorSite = studyTeam.isInvestigatorSite;
    this.name = studyTeam.name;
    this.participantType = studyTeam.participantType;
    this.statusId = studyTeam.statusId;
    this.statusName = studyTeam.statusName;
    this.studyTeamCompliance = new TeamCompliance(
      studyTeam.studyTeamCompliance
    );
    this.studyTeamDetailUrl = studyTeam.studyTeamDetailUrl;
    this.teamType = studyTeam.teamType;
  }
}

export default StudyTeam;
